import type {
  BetterstartCommandRuntime,
  RemoveCommandOptions
} from '@cli-types/core-engine/commands.js'
import { Command } from 'commander'

export function createRemoveCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('remove')
    .description('Remove installed BetterStart presets or integrations')
    .argument('<items...>', 'Preset or integration IDs to remove (e.g. blog r2)')
    .option('-f, --force', 'Skip confirmation prompt', false)
    .option('--integration', 'Remove integration IDs instead of content preset IDs', false)
    .option('--cwd <path>', 'Project root path')
    .action((items: string[], options: RemoveCommandOptions) => runtime.runRemove(items, options))
}
